import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {contentInvestment_template} from "../components/templates/contentInvestment_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class contentInvestment extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected contentInvestment_template: contentInvestment_template;

    protected getModuleName(){
        return "contentInvestment";
    }

    buildContent() : Array<Element>{

        this.contentInvestment_template = new contentInvestment_template( "contentInvestment", this.viewModel, this );
        this.template = this.contentInvestment_template;

        return [this.contentInvestment_template.build()];
    }

    public fillPage() : void{
        this.contentInvestment_template.initiateDimensionSelectTag();
        this.contentInvestment_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/contentInvestment/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.contentInvestment_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.contentInvestment_template.builtTemplate);
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.contentInvestment_template.setBrandFilterItems(responseParsed.departments);
        this.contentInvestment_template.setBrandSegments(responseParsed.brandSegments);
        this.contentInvestment_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.contentInvestment_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);
        this.contentInvestment_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.contentInvestment_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.contentInvestment_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.contentInvestment_template.setPostContentTypesGroupFilterItems();
        this.contentInvestment_template.setPermissions(responseParsed.permissions);
        this.contentInvestment_template.setArticleTypesFilterItems();
        this.contentInvestment_template.setDataRangesItems();
        this.contentInvestment_template.setPublishStatusItems();
        this.contentInvestment_template.setBrandSafetyFilterItems();

    }

    public getListData(): void{

        this.loadingIn(this.contentInvestment_template.builtTemplate.children.namedItem("list-results"));
        this.contentInvestment_template.hideExportButton();
        this.contentInvestment_template.hideExportReconciliationButton();

        this.contentInvestment_template.validateOrderBy();

        let subViewModel = this.contentInvestment_template.getViewModelForRequest();
        let baseApiUrl = '/api/contentInvestment/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.contentInvestment_template.resetSelectedRows();
                obj.contentInvestment_template.validationsList.clearMessages();
                obj.updateList(responseParsed.data);

                // LOADING : ends
                obj.loadingOut(obj.contentInvestment_template.builtTemplate.children.namedItem("list-results"));
            });
        };
    }

    protected updateList(responseParsed: any) {

        for (let item of responseParsed.reportDataPerDimensionGroupings) {
            item.Day = this.formatDate(item.Day + "T12:00:00");
        }

        this.contentInvestment_template.setReportData(responseParsed);
    }

    protected filterMultipleSelectorOnChange(){
        this.contentInvestment_template.resetDefaultDimensionFilters();
        this.contentInvestment_template.setSelectDimensionsObjects();
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public listReorder(){
        this.getListData();
    }

    private formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }

    public getCsvExportData(): void {

        let subViewModel = this.contentInvestment_template.getViewModelForRequest();
        subViewModel["export"] = true;
        let usrReq_url = '/api/contentInvestment/get';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCsvExportDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvExportDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                for (let item of response.data.reportDataPerDimensionGroupings) {
                    item.Day = obj.formatDate(item.Day + "T12:00:00");
                }

                obj.contentInvestment_template.setExportData(response.data);
            });
        }
    }

    public getCsvReconciliationData(): void {

        let subViewModel = this.contentInvestment_template.getViewModelForRequest();
        let usrReq_url = '/api/contentInvestment/reconciliation_data';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCsvReconciliationDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvReconciliationDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.contentInvestment_template.setExportReconciliationData(response.data.reconciliationData);
            });
        }
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url;
        let usrReq_callback;
        switch (id){

            case 'srEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteSrEditorsSuggestionsReturn;
                usrReq_url = '/api/emakiUsers/get/';
                break;
            }

            case 'jrEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteJrEditorsSuggestionsReturn;
                usrReq_url = '/api/emakiUsers/get/';
                break;
            }

            default :{

                usrReq_callback = this.onGetMultipleAutoCompleteCategoriesSuggestionsReturn;
                usrReq_url = '/api/emakiCategorySuggestions/';
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.contentInvestment_template.validationsList.clearMessages();
                if(responseParsed.data){

                    obj.contentInvestment_template.setSrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.contentInvestment_template.deactivateLoading();
            });
        };
    }

    protected onGetMultipleAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.contentInvestment_template.validationsList.clearMessages();
                if (responseParsed.data){

                    obj.contentInvestment_template.setJrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.contentInvestment_template.deactivateLoading();
            });
        };
    }

    protected onGetMultipleAutoCompleteCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.contentInvestment_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.contentInvestment_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.contentInvestment_template.deactivateLoading();
            });
        }
    }


}



// WEBPACK FOOTER //
// ./js/modules/contentInvestment.ts